import { css as r, keyframes as e } from "styled-components";
const t = /* @__PURE__ */ e([
  "0%{transform:rotate(0deg);}100%{transform:rotate(360deg);}"
]), a = ({ theme: o, bgOverlay: i = "solid" }) => {
  const n = {
    solid: /* @__PURE__ */ r([
      "background-color:",
      ";"
    ], o.componentColors.loadingSpinner.bgSolid),
    blur: /* @__PURE__ */ r([
      "background-color:",
      ";@supports (backdrop-filter:blur(10px)){backdrop-filter:blur(10px);}@supports not (backdrop-filter:blur(10px)){background-color:",
      ";}"
    ], o.componentColors.loadingSpinner.bgTranslucentBlur, o.componentColors.loadingSpinner.bgTranslucentNoBlur)
  };
  return n[i] || n.solid;
}, l = ({ active: o }) => o ? void 0 : /* @__PURE__ */ r([
  "opacity:0;visibility:hidden;display:none;"
]), s = {
  bg: /* @__PURE__ */ r([
    "display:flex;flex-direction:column;width:100%;height:100%;",
    " ",
    ""
  ], a, l),
  wrapper: ({ theme: o }) => /* @__PURE__ */ r([
    "display:flex;position:relative;border-radius:50%;width:128px;height:128px;color:",
    ";"
  ], o.componentColors.loadingSpinner.circle),
  contentWrapper: ({ theme: o }) => /* @__PURE__ */ r([
    "display:flex;margin:auto;flex-direction:column;text-align:center;align-items:center;box-sizing:border-box;padding:0 ",
    ";"
  ], o.space.sm),
  circle: /* @__PURE__ */ r([
    "box-sizing:border-box;display:block;position:absolute;width:100%;height:100%;margin:0;border-width:8px;border-style:solid;border-radius:50%;animation:",
    " 1.2s cubic-bezier(0.5,0,0.5,1) infinite;border-color:currentColor transparent transparent transparent;&:nth-child(1){animation-delay:-0.45s;}&:nth-child(2){animation-delay:-0.3s;}&:nth-child(3){animation-delay:-0.15s;}"
  ], t)
};
export {
  s as default
};
